import { twMerge } from 'tailwind-merge';
import { darePlatformFilters } from 'root/src/client/v2/drop/constants';
import { readableDropDareTypes, } from 'root/src/shared/constants/dropEvent';
import { categoriesMap } from 'root/src/client/web/commonStyles';
import { Badge } from 'root/src/client/v2/common/components/badge/Badge';
import { useBattlePassDaresType, useBattlePassDaresDifficultyLevels, useBattlePassDaresPlatforms, } from 'root/src/client/v2/battlePass/features/BattlePassDetails/contexts/battlePassDetails.context';
import { useBattlePassAvailableDaresFilter, useBattlePassDetails, } from 'root/src/client/v2/battlePass/features/BattlePassDetails/hooks/useBattlePassDetails';
export const BattlePassDaresFilters = () => {
    const { isLoading } = useBattlePassDetails();
    if (isLoading) {
        return <SkeletonDaresFilters />;
    }
    return (<div className="flex justify-between flex-wrap">
			<TypeFilters />
			<PlatformFilters />
			<DifficultiesFilter />
		</div>);
};
export const SkeletonDaresFilters = () => {
    return (<div className="flex flex-col justify-center items-center">
			<div className="animate-skeleton-loading bg-dark-2 w-full h-[50px] rounded-lg my-3"/>
		</div>);
};
export const TypeFilters = () => {
    const { availableTypes } = useBattlePassAvailableDaresFilter();
    const { dareTypes: currentDareTypes, onDareTypes } = useBattlePassDaresType();
    return (<div className="flex justify-start items-center gap-2 my-2">
			<p className="text-light-3 text-xs">TYPE:</p>
			{availableTypes.map((dareType) => {
            const label = readableDropDareTypes[dareType];
            const { color } = categoriesMap[dareType];
            const isActive = currentDareTypes.includes(dareType);
            return (<TypeBadge key={dareType} dareType={dareType} onChange={onDareTypes} isActive={isActive} label={label} color={color}/>);
        })}
		</div>);
};
export const TypeBadge = ({ isActive, label, color, onChange, dareType }) => {
    return (<Badge onClick={() => onChange({ isActive, value: dareType })} data-active={isActive} style={{ background: color }} className="select-none whitespace-nowrap cursor-pointer text-xs font-medium capitalize data-[active=true]:motion-safe:animate-slide-up data-[active=false]:motion-safe:animate-scale-up motion-safe:duration-150 brightness-50 data-[active=true]:brightness-100">
			{label}
		</Badge>);
};
export const PlatformFilters = () => {
    const { availablePlatforms } = useBattlePassAvailableDaresFilter();
    const availableDarePlatforms = darePlatformFilters.filter(platform => availablePlatforms.includes(platform.value));
    const { platforms, onPlatforms } = useBattlePassDaresPlatforms();
    return (<div className="flex justify-start items-center my-2">
			<p className="text-light-3 text-xs">PLATFORM:</p>
			{availableDarePlatforms.map(((platform) => {
            const isActive = platforms.includes(platform.value);
            return (<PlatformBadge key={platform.value} isActive={isActive} value={platform.value} icon={platform.icon} className={platform.className} onChange={onPlatforms}/>);
        }))}
		</div>);
};
export const PlatformBadge = ({ isActive, icon, value, className, onChange }) => {
    return (<div onClick={() => onChange({ isActive, value })} data-active={isActive} className="overflow-hidden mx-1 border-[3px] bg-white max-w-[34px] w-[34px] h-[34px] rounded-full cursor-pointer flex justify-center items-center data-[active=true]:border-primary border-transparent">
			<img className={twMerge('h-[28px]', className)} src={icon.src} alt={value}/>
		</div>);
};
export const DifficultiesFilter = () => {
    const { availableLevels } = useBattlePassAvailableDaresFilter();
    const { levels, onLevels } = useBattlePassDaresDifficultyLevels();
    return (<div className="flex justify-start items-center gap-2 my-2">
			<p className="text-light-3 text-xs">DIFFICULTY:</p>
			{availableLevels.map((level) => {
            const isActive = levels.includes(level);
            return (<DifficultyBadge key={level} isActive={isActive} level={level} onChange={onLevels}/>);
        })}
		</div>);
};
export const DifficultyBadge = ({ isActive, level, onChange }) => {
    return (<Badge onClick={() => onChange({ isActive, value: level })} data-active={isActive} className="select-none cursor-pointer text-xs font-medium bg-dark-1 capitalize data-[active=true]:motion-safe:animate-slide-up data-[active=false]:motion-safe:animate-scale-up motion-safe:duration-150 brightness-50 data-[active=true]:brightness-100">
			{level}
		</Badge>);
};
